import { useEffect, useState } from "react";

/**
 * Return a value that trails `value` by `delay` ms. Rapid updates
 * collapse into a single downstream change — used to prevent 5 refetches
 * when the user multi-selects 5 checkboxes in quick succession.
 *
 * Tune `delay` per call site:
 *   - 250-300 ms for filter multi-selects (feels "instant" but batches)
 *   - 500 ms+  for text search inputs
 */
export function useDebounced(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
